import { render, staticRenderFns } from "./BindsTableAlternateHeader.vue?vue&type=template&id=c4a71c28&"
import script from "./BindsTableAlternateHeader.vue?vue&type=script&lang=js&"
export * from "./BindsTableAlternateHeader.vue?vue&type=script&lang=js&"
import style0 from "./BindsTableAlternateHeader.vue?vue&type=style&index=0&id=c4a71c28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports